// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-cards-slider{margin-bottom:40px}.product-cards-slider .c-slider__swiper{margin:-14px;padding:14px}@media only screen and (min-width:992px){.product-cards-slider .related-dots,.product-cards-slider .related-scrollbar,.product-cards-slider .similar-scrollbar{display:none}}@media only screen and (min-width:992px){.product-cards-slider .related-bottom-wrapper{justify-content:space-between}}.product-cards-slider .c-slider__arrow svg{fill:#182028}", ""]);
// Exports
module.exports = exports;
